import { getJSTAccountStatus } from "../../../tare/model/JSTAccountStatus";
import { callPromiseSafely } from "../../util/callPromiseSafely";
import type { TareAccountStatus } from "../types/TareBridge";
import { getTareBridge } from "./getTareBridge";
import { isTareCodegenActive, isTareCodegenActiveSync } from "./tareCodegenMigration";

/**
 * Load account status from the native module.
 */
export async function getAccountStatus(): Promise<TareAccountStatus | null> {
  if (await isTareCodegenActive()) {
    return getJSTAccountStatus();
  }
  return callPromiseSafely(getTareBridge()?.getAccountStatus);
}

export function getAccountStatusSync(): TareAccountStatus | null {
  if (isTareCodegenActiveSync()) {
    return getJSTAccountStatus();
  }
  return getTareBridge()?.getAccountStatusSync?.() ?? null;
}
